// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("bs-platform/lib/js/curry.js");
var ListLabels = require("bs-platform/lib/js/listLabels.js");
var Infix$BsBastet = require("./Infix.bs.js");
var String$BsBastet = require("./String.bs.js");
var Default$BsBastet = require("./Default.bs.js");
var Functions$BsBastet = require("./Functions.bs.js");

function map(f) {
  return function (param) {
    return ListLabels.map(f, param);
  };
}

var Functor = {
  map: map
};

var Alt = {
  map: map,
  alt: ListLabels.append
};

function apply(fn_array, a) {
  return ListLabels.fold_left((function (acc, f) {
                return ListLabels.append(acc, ListLabels.map(f, a));
              }), /* [] */0, fn_array);
}

var Apply = {
  map: map,
  apply: apply
};

function pure(a) {
  return {
          hd: a,
          tl: /* [] */0
        };
}

var Applicative = {
  map: map,
  apply: apply,
  pure: pure
};

function flat_map(x, f) {
  return ListLabels.fold_left((function (acc, a) {
                return ListLabels.append(acc, Curry._1(f, a));
              }), /* [] */0, x);
}

var Monad = {
  map: map,
  apply: apply,
  pure: pure,
  flat_map: flat_map
};

var Plus = {
  map: map,
  alt: ListLabels.append,
  empty: /* [] */0
};

var Alternative = {
  apply: apply,
  pure: pure,
  map: map,
  alt: ListLabels.append,
  empty: /* [] */0
};

function fold_left(f, init) {
  return function (param) {
    return ListLabels.fold_left(f, init, param);
  };
}

function fold_right(f, init) {
  return function (param) {
    return ListLabels.fold_right(f, param, init);
  };
}

function Foldable_Fold_Map(funarg) {
  var partial_arg = Default$BsBastet.Fold_Map;
  var D = partial_arg(funarg, {
        fold_left: fold_left,
        fold_right: fold_right
      });
  return {
          fold_map: D.fold_map_default_left
        };
}

function Foldable_Fold_Map_Any(funarg) {
  var partial_arg = Default$BsBastet.Fold_Map_Any;
  var D = partial_arg(funarg, {
        fold_left: fold_left,
        fold_right: fold_right
      });
  return {
          fold_map: D.fold_map_default_left
        };
}

function Foldable_Fold_Map_Plus(funarg) {
  var partial_arg = Default$BsBastet.Fold_Map_Plus;
  var D = partial_arg(funarg, {
        fold_left: fold_left,
        fold_right: fold_right
      });
  return {
          fold_map: D.fold_map_default_left
        };
}

var Foldable = {
  fold_left: fold_left,
  fold_right: fold_right,
  Fold_Map: Foldable_Fold_Map,
  Fold_Map_Any: Foldable_Fold_Map_Any,
  Fold_Map_Plus: Foldable_Fold_Map_Plus
};

function unfold(f, init) {
  var match = Curry._1(f, init);
  if (match !== undefined) {
    return {
            hd: match[0],
            tl: unfold(f, match[1])
          };
  } else {
    return /* [] */0;
  }
}

var Unfoldable = {
  unfold: unfold
};

function Traversable(A) {
  var I = Infix$BsBastet.Apply(A);
  var traverse = function (f) {
    var arg = Curry._1(A.pure, /* [] */0);
    return function (param) {
      return ListLabels.fold_right((function (acc, x) {
                    return Curry._2(I.$less$star$great, Curry._2(I.$less$star$great, Curry._1(A.pure, (function (y, ys) {
                                          return {
                                                  hd: y,
                                                  tl: ys
                                                };
                                        })), Curry._1(f, acc)), x);
                  }), param, arg);
    };
  };
  var D = Default$BsBastet.Sequence({
        traverse: traverse
      });
  return {
          map: map,
          fold_left: fold_left,
          fold_right: fold_right,
          Fold_Map: Foldable_Fold_Map,
          Fold_Map_Any: Foldable_Fold_Map_Any,
          Fold_Map_Plus: Foldable_Fold_Map_Plus,
          traverse: traverse,
          sequence: D.sequence_default
        };
}

function Eq(E) {
  var eq = function (xs, ys) {
    if (ListLabels.length(xs) === ListLabels.length(ys)) {
      return ListLabels.fold_left((function (acc, param) {
                    if (acc) {
                      return Curry._2(E.eq, param[0], param[1]);
                    } else {
                      return false;
                    }
                  }), true, ListLabels.combine(xs, ys));
    } else {
      return false;
    }
  };
  return {
          eq: eq
        };
}

function Show(S) {
  var F = Functions$BsBastet.Foldable(Foldable);
  var M = Curry._1(F.Monoid, String$BsBastet.Monoid);
  var show = function (xs) {
    return "[" + (Curry._2(M.intercalate, ", ", ListLabels.map(S.show, xs)) + "]");
  };
  return {
          show: show
        };
}

var include = Infix$BsBastet.Monad(Monad);

var include$1 = Infix$BsBastet.Alternative(Alternative);

var Infix_$great$great$eq = include.$great$great$eq;

var Infix_$eq$less$less = include.$eq$less$less;

var Infix_$great$eq$great = include.$great$eq$great;

var Infix_$less$eq$less = include.$less$eq$less;

var Infix_$less$pipe$great = include$1.$less$pipe$great;

var Infix_$less$dollar$great = include$1.$less$$great;

var Infix_$less$hash$great = include$1.$less$hash$great;

var Infix_$less$star$great = include$1.$less$star$great;

var Infix = {
  $great$great$eq: Infix_$great$great$eq,
  $eq$less$less: Infix_$eq$less$less,
  $great$eq$great: Infix_$great$eq$great,
  $less$eq$less: Infix_$less$eq$less,
  $less$pipe$great: Infix_$less$pipe$great,
  $less$$great: Infix_$less$dollar$great,
  $less$hash$great: Infix_$less$hash$great,
  $less$star$great: Infix_$less$star$great
};

exports.Functor = Functor;
exports.Alt = Alt;
exports.Apply = Apply;
exports.Applicative = Applicative;
exports.Monad = Monad;
exports.Plus = Plus;
exports.Alternative = Alternative;
exports.Foldable = Foldable;
exports.Unfoldable = Unfoldable;
exports.Traversable = Traversable;
exports.Eq = Eq;
exports.Show = Show;
exports.Infix = Infix;
/* include Not a pure module */
